import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import Navbar from '../Navbar';
import logo from '../../images/Limitless-BNG_WordmarkLogo.png';
import './index.scss';

const HOURS = [
  ['Monday',    '11:30AM - 2AM'],
  ['Tuesday',   '11:30AM - 2AM'],
  ['Wednesday', '11:30AM - 2AM'],
  ['Thursday',  '11:30AM - 2AM'],
  ['Friday',    '11:30AM - 2AM'],
  ['Saturday',  '11:30AM - 2AM'],
  ['Sunday',    '11:30AM - 12AM'],
];

class NewAbout extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="new-about">
        <Navbar />

        <div className="about-body">
          <Link to="/landing2" className="back-btn">&#8592;</Link>

          <h1 className="about-title">About Us</h1>

          <div className="about-text">
            <p>At Limitless Bar and Grill, we believe the best moments in life are limitless.</p>
            <p>
              Limitless Bar and Grill was born out of the idea that life should never be limited by anything.
              We're about pushing the boundaries and having fun along the way. Whether you're here for a quick
              hangout or staying for a full night of laughter and good vibes, you're in the right place. Our
              space is designed for you to feel relaxed, where the music is always on point, the food is always
              delicious, and the drinks never disappoint.
            </p>
            <p>
              Our mission is to ensure that our flavours have no boundaries and every single bite makes your
              experience limitless.
            </p>
          </div>

          {/* Photo Gallery */}
          <div className="gallery">
            {/* Large photo top-right */}
            <div className="gallery-large">
              <div className="img-placeholder" />
            </div>
            {/* Two medium photos bottom-right */}
            <div className="gallery-medium">
              <div className="img-placeholder" />
            </div>
            <div className="gallery-medium">
              <div className="img-placeholder" />
            </div>
            {/* Small photo left */}
            <div className="gallery-small">
              <div className="img-placeholder" />
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer" id="contact">
          <div className="footer-top">
            <div className="footer-col">
              <h3>Contact Us</h3>
              <p>1450 Centre St., Unit 3</p>
              <p>L4J 3N1, Thornhill, ON</p>
              <br />
              <p>T: (905) 597-5252</p>
              <p>E: limitlessbarandgrill@gmail.com</p>
            </div>
            <div className="footer-col">
              <h3>Store Hours</h3>
              {HOURS.map(([day, hrs]) => (
                <div className="hours-row" key={day}>
                  <span>{day}</span>
                  <span>{hrs}</span>
                </div>
              ))}
            </div>
            <div className="footer-col footer-logo-col">
              <img src={logo} alt="Limitless Bar & Grill" className="footer-logo" />
            </div>
          </div>
          <div className="footer-social">
            <a href="https://www.facebook.com/limitlessbng" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
            </a>
            <a href="https://www.instagram.com/limitlessbng" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
          </div>
        </footer>
      </div>
    );
  }
}

export default NewAbout;
